import { memo, useMemo } from 'react';
import CityInfoPageView from './city_info_page_view';

import type { CityInfoPageViewModel } from './city_info_page_view_model';

export interface CityInfoPageControllerProps {
  viewModel: CityInfoPageViewModel;
}

const PageView = memo(CityInfoPageView);

const CityInfoPageController = (props: CityInfoPageControllerProps) => {
  const {
    viewModel: { 
      heading, 
      breadcrumbs,
      areaInsightsData,
      areaName,
      areaBlurb,
      areaBlurbHeading,
      isCustomPage,
      customPageConfig,
      recommendedListings,
      electedAddress,
      isCrawler,
    },
  } = props;

  // Extract insights data and surrounding cities from the area insights
  const insightsData = useMemo(() => areaInsightsData?.areaData, [areaInsightsData]);
  const surroundingCities = useMemo(() => areaInsightsData?.surroundingCities, [areaInsightsData]);

  return (
    <PageView 
      heading={heading} 
      breadcrumbs={breadcrumbs}
      insightsData={insightsData}
      surroundingCities={surroundingCities}
      areaName={areaName}
      areaBlurb={areaBlurb}
      areaBlurbHeading={areaBlurbHeading}
      isCustomPage={isCustomPage}
      customPageConfig={customPageConfig}
      recommendedListings={recommendedListings}
      areaSlug={electedAddress?.slug}
      isCrawler={isCrawler}
    />
  );
};

export default CityInfoPageController;

export { CityInfoPageController };
